export default __webpack_public_path__ + "static/media/chat.72659057.svg";